var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-snowman"},[_c('div',{staticClass:"snowman loading-snowman-1"}),_c('div',{staticClass:"snowman loading-snowman-2"})])}]

export { render, staticRenderFns }